export class CancelersService {
  constructor($q) {
    this.cancelers = {};
    this.$q = $q;
  }

  get(key) {
    let cancelers = this.cancelers;
    let old_canceler = cancelers[key];
    if (old_canceler) {
      // console.log('Another request started');
      old_canceler.resolve('Another request started');
    }
    let new_canceler = this.$q.defer();
    cancelers[key] = new_canceler;
    return new_canceler;
  }

  cancel(key) {
    if (key) {
      if (this.cancelers[key]) {
        this.cancelers[key].resolve('Aborted');
        delete this.cancelers[key];
      }
    }
    else {
      let keys = Object.getOwnPropertySymbols(this.cancelers);
      for (let i = 0; i < keys.length; ++i) {
        this.cancelers[keys[i]].resolve('Aborted');
      }
      this.cancelers = {};
    }
  }

  reset(key) {
    if (this.cancelers[key]) {
      delete this.cancelers[key];
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/cancelers.service.js